export const BaseUrl = "https://api.catalyze.co.in";

